
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/the-catch/[handle]",
      function () {
        return require("private-next-pages/the-catch/[handle].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/the-catch/[handle]"])
      });
    }
  